import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { graphql, StaticQuery } from 'gatsby';
import { theme } from '@upsolve/ui';

import ImageInContext from '../Media/ImageInContext';
import LinkCSS from '../Links/A.css';
import Mask from '../Media/Mask.div';
import getScreenerUrl from '../Links/getScreenerUrl';
import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import { ButtonLink } from '../Inputs/Button.span';

const CTATestimonial = (props) => (
  <StaticQuery
    query={graphql`
      query TestimonialCTAQuery {
        contentfulFreshStartDiary(
          filerName: { eq: "Denise Smith" }
        ) {
          slug
          filerName
          caseFiled
          storyQuote {
            storyQuote
          }
          filerImage {
            ...ImageNode
          }
        }
      }
    `}
    render={data => {
      return (
        <TestimonialWrapper>
          <div className="text-wrapper">
            <span className="label">Fresh Start Diaries</span>
            <div className={`quote ${data.contentfulFreshStartDiary.storyQuote.storyQuote.length > 80 ? 'condensed' : ''}`}>
              "{data.contentfulFreshStartDiary.storyQuote.storyQuote.trim()}"
              <br />
              <small><u><a aria-busy="false" href={`/fresh-starts/${data.contentfulFreshStartDiary.slug}/`}>I filed with Upsolve. Read my story →</a></u></small>
            </div>
            <div className="actions">
              <ButtonLink aria-busy="false" inverted href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.TESTIMONIAL, contentGroup: props.contentGroup })}>Get Free Bankruptcy Help</ButtonLink>
            </div>
          </div>
          <div className="filer-image">
            <Mask side="left">
              <ImageInContext
                alt={get(data.contentfulFreshStartDiary, 'filerImage.altText')}
                src={get(data.contentfulFreshStartDiary, 'filerImage.image.file.url')}
                fluid={get(data.contentfulFreshStartDiary, 'filerImage.image.fluid')}
              />
            </Mask>
          </div>
        </TestimonialWrapper>
      );
    }}
  />
);

const TestimonialWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px ${theme.colors.white['500']}, 0 5px 15px -5px rgba(0,0,0,.1);
  overflow: hidden;
  @media(max-width: 45em) {
    flex-direction: column-reverse;
  }
  .text-wrapper {
    flex-grow: 1;
    padding: 2em;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    a {
      ${LinkCSS}
    }
    .label {
      margin: 0;
      color: ${theme.colors.white['100']};
      font-weight: 500;
      font-size: 0.9em;
    }
    .quote {
      color: ${theme.colors.brand['500']};
      font-size: 1.4em;
      line-height: 1.5em;
      font-weight: 700;
      margin: 1em 0 2em;
      &.condensed {
        font-size: 1.25em;
      }
    }
    .actions {
      display: flex;
      align-items: center;
    }
    @media(max-width: 45em) {
      width: 100%;
      .label {
        text-align: center;
      }
      .actions a {
        width: 100%;
      }
    }
  }
  .filer-image {
    width: 40%;
    max-height: 100%;
    div > img {
      max-width: 100%;
    }
    @media(max-width: 45em) {
      width: 100%;
      height: 400px;
      overflow: hidden;
      display: none;
    }
  }
`;

export default CTATestimonial;
